import React, { memo } from 'react';
import { useLoadingCoordinator } from 'site-modules/personalized-search/hooks/use-loading-coordinator';

export function verdictDataProvider(WrappedComponent) {
  const Component = memo(props => {
    const { isFullyLoaded } = useLoadingCoordinator();

    return <WrappedComponent isFullyLoaded={isFullyLoaded} {...props} />;
  });

  return Component;
}
